import RootStore from '/src/context/stores/rootStore';

export default class BaseStore {
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
}
